<template>
    <div class="wrapper">
      <div class="content-container">
        <div class="stingy-card">
          <h2>🎉 RRSP Match - Yes, They Are the Closest Thing to Free Money You'll Get! 🎉</h2>
  
          <p>Are you aware of the untapped bounty that might be sitting right under your whiskers? Much like us cats, who find delight in swatting treasures off the table, many folks miss out on a different kind of treasure - employer RRSP matches. These are not just mere trinkets but real, tangible morsels of wealth, ripe for the taking.
  
  Think of it as a game of feline finesse, where every dollar you contribute to your RRSP is like a playful nudge towards an object on the edge of a table. Your employer's match is the satisfying clink as it hits the floor – but better, because you don't have to feign innocence when caught!
          </p>
  
          <p> Just like we cats know the perfect angle to send a pen rolling off the desk, you too can master the art of maximizing your RRSP contributions. Every bit you put in is met with a generous dollop of 'free money' from your employer. It’s a purr-fect partnership!
  
  Why let this opportunity be like a sunbeam that fades away, un-basked in? Take advantage of it! Leverage these matches to amplify your savings, bolster your financial future, and maybe even stash away a little extra for those rainy days or sunny windowsills.
  
  So next time, before you stretch out for a cozy nap in your financial comfort zone, ask yourself - are you making the most of the RRSP match? It's a chance to paw-sitively impact your savings, and trust us, it’s as delightful as a full bowl of treats or a long, uninterrupted nap in a sunlit spot. 🐾💤📈
          </p>
        </div>
      </div>
    </div><br><br>
    <div class="wrapper">
      <div class="content-container">
        <div class="stingy-card">
    <div class="rrsp-calculator">
      <h2>RRSP Match Calculator</h2>
      <!-- Employee Salary -->
      <label for="salary">Employee's Annual Salary ($):</label>
      <input type="range" id="salary" v-model="salary" min="0" max="300000" step="1000" class="custom-slider" />
      <div class="value-display">{{ formatCurrency(salary) }}</div>
      <!-- Employer Match Percentage -->
      <label for="employerMatch">Employer Match Percentage (%):</label>
      <input type="number" id="employerMatch" v-model="employerMatch" min="0" max="100" step="1" />
      <!-- Employer Contribution Percentage -->
      <label for="employerContribution">Employer Contribution Percentage of Salary (%):</label>
      <input type="number" id="employerContribution" v-model="employerContribution" min="0" max="10" step="0.1" />
      <!-- Max Contribution Allowed -->
      <label for="maxEmployeeContribution">Max Employee Contribution Allowed (%):</label>
      <input type="number" id="maxEmployeeContribution" v-model="maxEmployeeContribution" min="0" max="20" step="0.1" />
      <!-- Results -->
      <div class="results">
        <p>Employee Contribution: {{ formatCurrency(calculateEmployeeContribution) }}</p>
        <p>Employer Contribution: {{ formatCurrency(calculateEmployerContribution) }}</p>
        <p>Total RRSP Contribution: {{ formatCurrency(totalContribution) }}</p>
      </div>
    </div>
    </div>
    </div>
    </div>
    
    
    <br><br><br><br><br><br>
  </template>
  
  <script setup>
  import { ref, computed } from 'vue';
  
  const salary = ref(50000);
  const employerMatch = ref(50);
  const employerContribution = ref(3);
  const maxEmployeeContribution = ref(6);
  
  const calculateEmployeeContribution = computed(() => {
    return (salary.value * maxEmployeeContribution.value) / 100;
  });
  
  const calculateEmployerContribution = computed(() => {
    const matchedContribution = (calculateEmployeeContribution.value * employerMatch.value) / 100;
    const employerContributionAmount = (salary.value * employerContribution.value) / 100;
    return Math.min(matchedContribution, employerContributionAmount);
  });
  
  const totalContribution = computed(() => {
    return calculateEmployeeContribution.value + calculateEmployerContribution.value;
  });
  
  const formatCurrency = (value) => {
    return `$${Number(value).toLocaleString('en-US', { minimumFractionDigits: 2 })}`;
  };
  </script>
  
  
  
  
  <style scoped>
  
  .custom-slider {
    -webkit-appearance: none;
    width: 100%;
    margin: 10px 0;
    background: transparent;
    height: 5px; /* Set the height of the slider */
    border-radius: 5px; /* Rounded slider */
  }
  
  .custom-slider::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 20px;
    height: 20px;
    background: #800080; /* Purple thumb */
    cursor: pointer;
    border-radius: 50%;
    box-shadow: 0 0 5px rgba(128, 0, 128, 0.6); /* Light purple glow */
  }
  
  .custom-slider::-webkit-slider-runnable-track {
    width: 100%;
    height: 10px; /* Increase the height for a bolder appearance */
    background: linear-gradient(45deg, #4caf50, #f44336, #2196f3); /* Gradient background */
    border-radius: 5px; /* Rounded track */
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.25); /* Add a subtle shadow for depth */
  }
  .wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  }
  
  .content-container {
  background-color: #4A148C ;  /* Light orange color */
  color: black;
  padding: 20px;
  border-radius: 20px;  /* Adjust this value to your preference */
  overflow: hidden; 
  }
  .stingy-card {
  flex: 1;  /* Take up equal width as the iframe */
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  background-color: white
  }
  
  
  
  
  
    input[type=range]::-webkit-slider-thumb {
      -webkit-appearance: none;
      appearance: none;
      width: 20px;
      height: 20px;
      background: #4A148C; /* Purple */
      cursor: pointer;
      border-radius: 40%;
    }
  
    input[type=range]::-webkit-slider-runnable-track {
      width: 100%;
      height: 8px;
      background: #d3d3d3;
      border-radius: 5px;
    }
  
    /* Hover effect on buttons */
    input[type=number] {
      padding: 10px;
      border: 1px solid #d3d3d3;
      border-radius: 5px;
      outline: none;
      transition: border-color 0.3s, box-shadow 0.3s;
    }
  
    input[type=number]:hover {
      border-color: #4A148C; /* Purple */
    }
  
    /* Results section */
    .results {
      background: #f3f3f3;
      padding: 20px;
      border-radius: 10px;
  
      margin-top: 20px;
    }
  
    .results p {
      margin: 10px 0;
      font-weight: bold;
    }
  
    /* Styling value display */
    .value-display {
      text-align: center;
      margin-top: 10px;
      font-size: 18px;
  
    }
  </style>